'use strict';

var React = require('react'),
    Group = require('../organisms/Group'),
    SidebarBody = require('../organisms/SidebarBody'),
    createStoreMixin = require('../mixins/createStoreMixin'),
    StampDraftStore = require('../stores/StampDraftStore'),
    DraftActionCreators = require('../actions/DraftActionCreators'),
    PureRenderMixin = require('../mixins/PureRenderMixin'),
    UserStore = require('../stores/UserStore'),
    EmptyState = require('../molecules/EmptyState'),
    Button = require('../atoms/Button'),
    { transitionTo } = require('../router'),
    SidebarActionCreators = require('../actions/SidebarActionCreators');

var Drafts = React.createClass({
  mixins: [createStoreMixin(StampDraftStore, UserStore), PureRenderMixin],

  getStateFromStores() {
    return {
      drafts: StampDraftStore.getDrafts()
    };
  },

  componentDidMount() {
    DraftActionCreators.requestDraftPage(true);
  },

  render: function () {
    var { stampId } = this.props,
        getItemProps;

    getItemProps = function (item) {
      return {
        routeParams: { stampId: item.uuid }
      };
    };

    return (
      <SidebarBody title='My Drafts'>
        <Group type='stamps'
               items={this.state.drafts}
               itemProps={{
                 size: 'small',
                 showLikes: false,
                 allowEmptyThumbnail: true,
                 routeName: 'draftCompose'
               }}
               getItemProps={getItemProps}
               context='sidebar'
               mode='grid'
               columns={2}
               isExpectingPage={StampDraftStore.isExpectingPage(stampId)}
               isLastPage={StampDraftStore.isLastPage(stampId)}
               isInvalidated={StampDraftStore.isInvalidated(stampId)}
               loadNextPage={this.requestNextPage}>
          <EmptyState label='You have no saved drafts.'
                      absoluteCenter>
            <Button onClick={this.handleCreateStampClick}>
              Create a Stamp
            </Button>
          </EmptyState>
        </Group>
      </SidebarBody>
    );
  },

  handleCreateStampClick() {
    SidebarActionCreators.hideSidebar();
    transitionTo('draftCompose', { stampSegment: 'new' });
  },

  requestNextPage() {
    DraftActionCreators.requestDraftPage();
  }
});

module.exports = Drafts;



/** WEBPACK FOOTER **
 ** ./sidebar/Drafts.jsx
 **/